var _path, _path2, _path3, _path4, _path5, _line, _rect, _rect2, _rect3, _rect4, _rect5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9973 14.7709V5.08193C32.9973 4.31215 32.281 3.68811 31.3974 3.68811H2.59986C1.71628 3.68811 1 4.31215 1 5.08193V24.5954C1 25.3652 1.71628 25.9893 2.59986 25.9893H19.978",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.123 3.68811L29.123 0.958826",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8809 3.68811L20.8809 0.958826",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 3.68811L13.125 0.958826",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88086 3.68811L4.88086 0.958826",
    stroke: "black",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.998,
    y1: 7.5816,
    x2: 1.00076,
    y2: 7.5816,
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.88086,
    y: 11.4448,
    width: 5.81769,
    height: 3.39365,
    stroke: "black",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.88086,
    y: 18.717,
    width: 5.81769,
    height: 3.39365,
    stroke: "black",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0918,
    y: 11.4448,
    width: 5.81769,
    height: 3.39365,
    stroke: "black",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0918,
    y: 18.717,
    width: 5.81769,
    height: 3.39365,
    stroke: "black",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3047,
    y: 11.4448,
    width: 5.81769,
    height: 3.39365,
    stroke: "black",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2793 18.0735L29.2793 27.793",
    stroke: "black",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5566 24.0724L29.2764 28.0011",
    stroke: "black",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24.0724L29.2802 28.0011",
    stroke: "black",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5566 30.0254L32.9978 30.0412",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCalendar);
export default __webpack_public_path__ + "static/media/download_calendar.8513d99baa58d9a249dfa0332cb85fd3.svg";
export { ForwardRef as ReactComponent };